import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from "react-redux";
import {ShippingPage} from "./ShippingPage"
import {store} from '../../../index';

const page = document.getElementById('shipping-page');

if (page !== null) {
  ReactDOM.render(
    <Provider store={store}>
      <ShippingPage cartId={page.dataset.cartId}/>
    </Provider>,
    page
  );
}
